import MentionDecorator from "./mention.js";
const nodeViewDecorators = [MentionDecorator];
export {
  nodeViewDecorators
};
//# sourceMappingURL=index.js.map
